<div [class]="defaultCellContainerClass">
  <div class="cell-text" [class.with-warning]="warningTooltipText()" role="row">
    @if (params()["templateWithContext"]) {
      <ng-container
        *ngTemplateOutlet="
          params()['templateWithContext']['template'];
          context: params()['templateWithContext']['context']
        "
      ></ng-container>
    }
    @if (hasLink()) {
      <app-form-link [link]="link()" [openInNewTab]="params()['openInNewTab']">
        {{ value() }}
      </app-form-link>
    } @else if (params()["isLinkStyle"]) {
      <a>{{ value() }}</a>
    } @else {
      {{ value() }}
    }
  </div>
  @if (warningTooltipText()) {
    <div class="cell-warning">
      <mat-icon
        class="suffix-icon error warn-icon"
        svgIcon="action_pending"
        [tp]="warningTooltipText()"
      ></mat-icon>
    </div>
  }
  @if (params()["suffix"]) {
    <span class="cell-suffix">{{ params()["suffix"] }}</span>
  }
  <div class="cell-actions">
    @for (button of buttons(); track button) {
      @if (show(button)) {
        <app-button
          stopPropagation
          [tp]="button.tooltipTemplate ? tooltipTemplate : tooltip(button)"
          [tpIsLazy]="true"
          [disabled]="isDisabled(button)"
          (pressed)="onClick(button, $event)"
          type="icon"
          size="medium"
        >
          @if (button.svgIcon) {
            <mat-icon
              [class]="iconClass(button)"
              icon-medium-18
              [svgIcon]="button.svgIcon"
            ></mat-icon>
          } @else {
            <mat-icon [class]="iconClass(button)" icon-medium-18>
              {{ icon(button) }}
            </mat-icon>
          }

          @if (button.isUpload) {
            <input type="file" class="hide" (change)="button.onFileSelected($event)" />
          }
        </app-button>

        <ng-template #tooltipTemplate>
          @switch (button.tooltipTemplate) {
            @case ("orbifyDeforestation") {
              <div>
                <b>
                  <ng-container i18n="@@orbify.tooltip.projectarea">Project area (ha)</ng-container>
                  :
                </b>
                {{
                  data()?.providerResponse?.projectAreaHa
                    ? (data().providerResponse.projectAreaHa | number: defaultNumberRounding)
                    : "-"
                }}
              </div>
              <div>
                <b>
                  <ng-container i18n="@@orbify.tooltip.lostforestarea">
                    Lost forest area (ha)
                  </ng-container>
                  :
                </b>
                @if (data()?.providerResponse?.lostForestAreaHa) {
                  {{ data().providerResponse.lostForestAreaHa | number: defaultNumberRounding }}
                  {{
                    data()?.providerResponse?.lostForestAreaPercent
                      ? "(" +
                        (data().providerResponse.lostForestAreaPercent
                          | number: defaultNumberRounding) +
                        "%)"
                      : ""
                  }}
                } @else {
                  -
                }
              </div>
            }
          }
        </ng-template>
      }
    }
  </div>
</div>
